import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../../styles'

export type RangeProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

function RangeComponent({ children, id = String(Math.random()), onChange, ...inputProps }: RangeProps) {
  return (
    <>
      <S.range.InputRange
        onChange={(event) => {
          onChange && onChange(event)
        }}
        list={id}
        hasDatalist={Boolean(children && id)}
        {...inputProps}
      />
      {children && id && <S.range.Datalist $id={id}>{children}</S.range.Datalist>}
    </>
  )
}
export const Range = styled(RangeComponent)``
